import React, { useCallback, useEffect, useState } from "react";
import Chart, { ReactGoogleChartEvent } from "react-google-charts";
import { FormatAtlasData } from "./ConvertData";
import AtlasData from "./DemoAtlas.json";
import { ReactComponent as Cross } from "../../../icons/cross.svg";
import "./Atlas.css";
import {
  buildBaseUrl,
  buildHeaderTokens,
} from "../../../Rest_api/Network_utility";
import Hamburger from "../../../components/Hamburger";
import Loading from "../../../components/Loading";
import { SearchBox } from "../../../components/Search";
import { ReactComponent as GNAiIcon } from "../../../icons/gnai_logo.svg";

export function PowerAtlas() {
  const colorMapping: {
    [key: string]: string;
  } = {
    Solar: "orange",
    Wind: "green",
    Thermal: "yellow",
    Hydro: "blue",
    Nuclear: "red",
   "Bio Power": "lightgreen",
  };

  const [atlasData, setAtlasData] = React.useState<any>({
    data: [],
  });
  const [loading, setLoading] = useState(false);
  let [selectedLegend, setSelectedLegend] = React.useState<string[]>([]);
  // console.log(selectedLegend)
  const [data, setData] = React.useState(
    FormatAtlasData(AtlasData.data, getSelectedLegends())
  );

  const [selectedPlant, setSelectedPlant] = React.useState<any>();
  const [selectedUniquePlant, setUniquePlant] = React.useState<any[]>([]);
  const [selectedStation, setselectedStation] = React.useState<any[]>([]);

  let fetchAtlasData = useCallback(async () => {
    setLoading(true);
    // https://datahub.gna.energy/power_atlas_api
    const response = await fetch(buildBaseUrl("data/power_atlas_api"), {
      method: "GET",
      headers: await buildHeaderTokens(),
    });
    const res = await response.json();
    setAtlasData(res);
    setUniquePlant(
      Array.from(new Set(res.data.map((item: any) => item["Name of Project"])))
    );
    setData(FormatAtlasData(res.data, getSelectedLegends()));
    setLoading(false);
  }, []);

  // function handleSelectChange(selectedRow: any) { }
  async function handleFilterData() {
    setData(FormatAtlasData(AtlasData.data, getSelectedLegends()));
    // sleep for a second
    await new Promise((r) => setTimeout(r, 100));

    let filteredAtlasData = atlasData.data;
    if (selectedLegend.length > 0) {
      filteredAtlasData = atlasData.data.filter((item: any) =>
        selectedLegend.includes(item["Type"])
      );
    } else {
      filteredAtlasData = atlasData.data;
    }
                
    setUniquePlant(
      Array.from(
        new Set(filteredAtlasData.map((item: any) => item["Name of Project"]))
      )
    );

    if (selectedStation.length > 0) {
      const selectedLabels = selectedStation.map((g) => g.label);

      filteredAtlasData = filteredAtlasData.filter((item: any) =>
        selectedLabels.includes(item["Name of Project"])
      );
    }
    setData(FormatAtlasData(filteredAtlasData, getSelectedLegends()));
    // console.log("--------------------------", "Date when filtering")
    // console.log(data);
  }
  useEffect(() => {
    handleFilterData();
  }, [selectedStation, selectedLegend]);

  useEffect(() => {
    fetchAtlasData();
  }, [fetchAtlasData]);

  function getSelectedLegends(): string[] {
    if (selectedLegend.length === 0) {
      return Object.keys(colorMapping);
    }
    return selectedLegend;
  }
  function onlyUnique(value: any, index: any, array: any) {
    return array.indexOf(value) === index;
  }

  function chartEvents(dataChart: any): ReactGoogleChartEvent[] {
    return [
      {
        eventName: "select",
        callback({
          chartWrapper,
          props,
          eventArgs,
        }: {
          chartWrapper: any;
          props: any;
          eventArgs: any;
        }) {
          const selectedId = chartWrapper.getChart().getSelection();

          if (selectedId.length) {
            const selectedRow = selectedId[0].row;
            setSelectedPlant(
              atlasData.data.find(
                (item: any) => item["ID"] === data.data[selectedRow + 1][4]
              )
            );
          } else {
          }
        },
      },
      {
        eventName: "ready",
        callback: ({
          chartWrapper,
          google,
        }: {
          chartWrapper: any;
          google: any;
        }) => {},
      },
    ];
  }

  return (
    <>
      <div className="dashboard-header flex justify-between items-center relative">
        <div className="flex items-center gap-5">
          <GNAiIcon width={80} />
          {/* <Hamburger /> */}
        </div>
        <div className="w-full text-center">
          <h1 className="text-[#6F6D7C] !text-[18px]"> Power Atlas </h1>
        </div>
      </div>

      <div
        className="main-legend-wrapper rounded-md w-fit h-[32px] px-2 py-0 flex items-center justify-center gap-[10px]"
        style={{
          position: "absolute",
          bottom: "8%",
          left: "50%",
          transform: "translateX(-50%)",
          backgroundColor: "transparent",
          border: "1px solid #ccc",
          zIndex: 50,
        }}
      >
        {Object.keys(colorMapping).map((key, index) => {
          const isSelected = selectedLegend.includes(key);
          return (
            <div
              key={index}
              onClick={() => {
                if (selectedLegend.includes(key)) {
                  const updated = selectedLegend.filter((item) => item !== key);
                  setSelectedLegend(updated);
                  handleFilterData();
                } else {
                  const updated = [...selectedLegend, key];
                  setSelectedLegend(updated);
                  handleFilterData();
                }
              }}
              className="h-full px-2 cursor-pointer flex items-center gap-2"
              style={{
                backgroundColor: "transparent",
                color: "#2F4F4F",
                borderLeft: index !== 0 ? "1px solid #ccc" : "none",
              }}
            >
              <div
                className="w-2 h-2 rounded-full"
                style={{ backgroundColor: colorMapping[key] }}
              ></div>
              <span
                className={`text-xs ${
                  !isSelected ? "font-medium" : "font-bold"
                }`}
              >
                {key}
              </span>
            </div>
          );
        })}
      </div>
      <div className="left-12 ml-1 mt-5 z-10 flex justify-center"></div>
      {loading && <Loading />}

      <div className="fixed  right-8 z-10 flex justify-center">
        <div className="plantInfo bg-white rounded-t-lg shadow-lg">
          {selectedPlant && (
            <>
              <div className="flex justify-between items-center p-1 pl-4 pr-4 align-middle	 ">
                <h1 className="text-lg">Plant Info</h1>
                <button
                  onClick={() => {
                    setSelectedPlant(null);
                  }}
                  className="text-lg "
                >
                  <Cross />
                </button>
              </div>
              <table className="w-full text-base table-fixed border-collapse generatorTable">
                <thead></thead>
                <tbody>
                  {Object.keys(selectedPlant).map((key, index) => {
                    if (
                      key.includes("Latitude") ||
                      key.includes("Longitude") ||
                      key.includes("ID")
                    ) {
                      return null;
                    }
                    return (
                      <tr
                        key={index}
                        className="border-t border-[#E4E7ED] bg-white"
                      >
                        <th className="text-left text-[#F1935C] px-4 py-2 font-medium w-1/2 bg-white">
                          {key}
                        </th>
                        <td className="text-right text-gray-500 px-4 py-2 w-1/2 bg-white">
                          {selectedPlant[key]}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>
      <center>
        <div className=" w-[%] m-auto rounded-[12px] bg-white p-4 ml-[96px]">
          <div className="relative border rounded-[12px] ">
            <div className="chart-search-box">
              <SearchBox
                options={selectedUniquePlant.map((item) => {
                  return { value: item, label: item };
                })}
                isMany={true}
                placeholder="Search Plant"
                selectedOptions={selectedStation}
                onChange={setselectedStation}
              />
            </div>
            {data.data.length > 0 && (
              <Chart
                chartType="GeoChart"
                width="96%"
                height="800px"
                data={data.data.map((subArray) => subArray.slice(0, 4))}
                chartEvents={chartEvents(data.data)}
                chartWrapperParams={{
                  view: { columns: [0, 1, 2, 3] },
                }}
                options={{
                  legend: "none",
                  resolution: "provinces",
                  sizeAxis: { minValue: 0, maxValue: 100 },
                  enableRegionInteractivity: true,
                  region: "IN",
                  colorAxis: { colors: data.colors },
                  displayMode: "markers",
                  domain: "IN",
                  //is3D: true,
                  backgroundColor: "#FFFFFF",
                  datalessRegionColor: "#FFFFFF",
                  defaultColor: "#FFFFFF",
                }}
              />
            )}
          </div>
        </div>
      </center>
    </>
  );
}
